import { useCart } from '~/composables/useCart';
import { useUser } from '~/composables/_next/useUser';
import FormatPrice from '~/components/Atoms/FormatPrice.vue';
export default defineComponent({
  name: 'CartSummary',
  components: {
    FormatPrice: FormatPrice
  },
  setup: function setup() {
    var _useCart = useCart(),
      cart = _useCart.cart,
      totalPriceCart = _useCart.totalPriceCart,
      totalPriceItems = _useCart.totalPriceItems;
    var _useUser = useUser(),
      isIntracomGroup = _useUser.isIntracomGroup;
    var shippingPrice = computed(function () {
      var _cart$value, _cart$value$shippingI, _cart$value$shippingI2, _cart$value2, _cart$value2$shipping;
      var discountedCentAmount = (_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : (_cart$value$shippingI = _cart$value.shippingInfo) === null || _cart$value$shippingI === void 0 ? void 0 : (_cart$value$shippingI2 = _cart$value$shippingI.discountedPrice) === null || _cart$value$shippingI2 === void 0 ? void 0 : _cart$value$shippingI2.value.centAmount;
      var centAmount = (_cart$value2 = cart.value) === null || _cart$value2 === void 0 ? void 0 : (_cart$value2$shipping = _cart$value2.shippingInfo) === null || _cart$value2$shipping === void 0 ? void 0 : _cart$value2$shipping.price.centAmount;
      if (discountedCentAmount !== undefined) {
        return discountedCentAmount / 100;
      }
      return centAmount !== undefined ? centAmount / 100 : null;
    });
    return {
      isIntracomGroup: isIntracomGroup,
      shippingPrice: shippingPrice,
      totalPriceCart: totalPriceCart,
      totalPriceItems: totalPriceItems
    };
  }
});